import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n\n  .container {\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  background: #f5f8fb;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: ",
        ";\n  height: 100%;\n  line-height: 1.5;\n  background: no-repeat 50% 50% / cover;\n  background-image: ",
        ";\n  background-position: ",
        ";\n  background-size: contain;\n\n  .panel_inner {\n    height: 100%;\n    text-align: ",
        ";\n    padding-top: 80px;\n    padding-left: ",
        ";\n\n    p {\n      letter-spacing: -0.25px;\n    }\n\n    .title {\n      font-size: 48px;\n      font-weight: bold;\n      color: ",
        ";\n      word-break: keep-all;\n      margin: 0;\n    }\n\n    .desc {\n      font-size: 32px;\n      color: ",
        ";\n      margin-top: 16px;\n      margin-bottom: 0;\n    }\n\n    img {\n      margin-top: 48px;\n    }\n\n    @media (max-width: 1200px) {\n      padding-top: 64px;\n\n      .title {\n        font-size: 36px;\n      }\n      .desc {\n        font-size: 28px;\n        margin-top: 8px;\n      }\n      img {\n        width: 90%;\n        max-width: 500px;\n      }\n    }\n    @media (max-width: 768px) {\n      width: inherit;\n      padding-top: 48px;\n\n      .title {\n        font-size: 28px;\n        text-shadow: 0 0 5px rgb(255 255 255);\n\n        br {\n          display: none;\n        }\n      }\n      .desc {\n        font-size: 20px;\n        text-shadow: 0 0 5px rgb(255 255 255);\n      }\n      img {\n        margin-top: 24px;\n      }\n    }\n  }\n\n  @media (max-width: 1200px) {\n    padding: 0 20px;\n  }\n  @media (max-width: 768px) {\n    padding: 0;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  letter-spacing: -0.25px;\n  padding: 80px 0 150px;\n\n  .title {\n    font-size: 24px;\n    font-weight: bold;\n    color: ",
        ";\n    margin-bottom: 40px;\n  }\n\n  @media (max-width: 1200px) {\n    padding-left: 20px;\n    padding-right: 20px;\n\n    .title {\n      font-size: 20px;\n      margin-bottom: 24px;\n    }\n  }\n  @media (max-width: 768px) {\n    padding: 36px 0 48px;\n\n    .title {\n      font-size: 16px;\n      margin-bottom: 12px;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { IntroVideo } from "./components/IntroVideo";
import { IntroFaqs } from "./components/IntroFaqs";
import { Container } from "@/components";
import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { TextBreak } from "@/components/TextBreak";
import useNewPlanUI from "@/lib/utils/newPlan";
const FeatureSectionWrapper = styled.section.withConfig({
    componentId: "sc-2670ac54-0"
})(_templateObject(), (param)=>{
    let { color  } = param;
    return color ? color : "transparent";
});
const FaqSectionWrapper = styled.section.withConfig({
    componentId: "sc-2670ac54-1"
})(_templateObject1());
const SectionTRPanel = styled.div.withConfig({
    componentId: "sc-2670ac54-2"
})(_templateObject2(), (param)=>{
    let { position  } = param;
    return position ? "flex-" + position : "center";
}, (param)=>{
    let { image  } = param;
    return image ? "url(" + image + ")" : "none";
}, (param)=>{
    let { position  } = param;
    return position === "start" ? "right center" : position === "end" ? "left center" : "center center";
}, (param)=>{
    let { position  } = param;
    return position ? "left" : "center";
}, (param)=>{
    let { position  } = param;
    return position === "end" ? "24px" : 0;
}, themeGet("text.0", "#1B1B29"), themeGet("text.0", "#1B1B29"));
const FaqWrapper = styled.div.withConfig({
    componentId: "sc-2670ac54-3"
})(_templateObject3(), themeGet("text.0", "#1B1B29"));
export const IntroducePage = (param)=>{
    let {} = param;
    // TODO New 요금제 : 사업부에서 추가 내용 수급 필요
    const faqs = useNewPlanUI().useNewPlan ? [
        {
            title: "쏠북에서는 왜 저작권 문제가 없나요?",
            id: 1,
            content: /*#__PURE__*/ _jsxs("div", {
                style: {
                    lineHeight: "1.5"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            "쏠북은 출판사가 정식으로 출판사의 콘텐츠에 대한 이용 권리를 허가한 국내 유일의 디지털 교재 플랫폼입니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            " 라이선싱 거래는 이용 권리에 대한 거래를 뜻합니다."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            marginTop: "10px"
                        },
                        children: [
                            "쏠북에서 이용권리를 거래하시면, 즉, 수업콘텐츠 라이선스를 계약하시면,",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            " 저작자의 정식 허락 하에 수업 전송, 자료 저작 등 교재에 기반한 다양한 교육활동을 마음껏 할 수 있습니다."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            marginTop: "10px"
                        },
                        children: [
                            "- 저작자의 권리 보호를 위해 수업콘텐츠를 쏠북 플랫폼 뷰어를 통해 제공합니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            "- 다양한 교육활동을 편리하게 할 수 있도록 편집툴, 마켓 등의 기능을 제공합니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            "- 교재의 단순 복제나 전체 인쇄는 저작권자의 허락 범위 내에 있지 않은 경우가 많으니 꼭 참고해주세요."
                        ]
                    })
                ]
            })
        },
        {
            title: "수업콘텐츠 라이선스 계약 후, 파일로 다운로드할 수 있나요?",
            id: 3,
            content: /*#__PURE__*/ _jsxs("div", {
                style: {
                    lineHeight: "1.5"
                },
                children: [
                    "수업콘텐츠 라이선스를 계약하신 후, 쏠북 플랫폼 뷰어로 콘텐츠를 확인 및 이용하실 수 있습니다.",
                    /*#__PURE__*/ _jsx(TextBreak, {}),
                    "쏠북은 저작권자의 권리 보호를 위해 쏠북 플랫폼 뷰어를 제공하므로,",
                    /*#__PURE__*/ _jsx(TextBreak, {}),
                    "쏠북에 접속 시 언제든지 어디서나 편리하게 이용할 수 있습니다."
                ]
            })
        }
    ] : [
        {
            title: "쏠북에서는 왜 저작권 문제가 없나요?",
            id: 1,
            content: /*#__PURE__*/ _jsxs("div", {
                style: {
                    lineHeight: "1.5"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            "쏠북은 출판사가 정식으로 출판사의 콘텐츠에 대한 이용 권리를 허가한 국내 유일의 디지털 교재 플랫폼입니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            " 라이선싱 거래는 이용 권리에 대한 거래를 뜻합니다."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            marginTop: "10px"
                        },
                        children: [
                            "쏠북에서 이용권리를 거래하시면, 즉, 수업콘텐츠 라이선스를 계약하시면,",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            " 저작자의 정식 허락 하에 수업 전송, 자료 저작 등 교재에 기반한 다양한 교육활동을 마음껏 할 수 있습니다."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            marginTop: "10px"
                        },
                        children: [
                            "- 저작자의 권리 보호를 위해 수업콘텐츠를 쏠북 플랫폼 뷰어를 통해 제공합니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            "- 다양한 교육활동을 편리하게 할 수 있도록 편집툴, 마켓 등의 기능을 제공합니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            "- 교재의 단순 복제나 전체 인쇄는 저작권자의 허락 범위 내에 있지 않은 경우가 많으니 꼭 참고해주세요."
                        ]
                    })
                ]
            })
        },
        {
            title: "라이트/베이직/프로 라이선스 프로그램은 어떤 차이가 있나요?",
            id: 2,
            content: /*#__PURE__*/ _jsxs("div", {
                style: {
                    lineHeight: "1.5"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            "1. 각 라이선스 프로그램 수업콘텐츠를 이용하는 선생님과 학생 수에 따라 나뉘어 있습니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    margin: "10px 0"
                                },
                                children: [
                                    "※ 예를 들어, 선생님께서 [라이트] 수업콘텐츠 라이선스를 계약했다면, ",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "선생님을 제외한 4명의 학생에게 공유를 하거나, 출력하여 나눠줄 수 있습니다."
                                ]
                            }),
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            "- 라이트 : 선생님과 학생 최대 5명까지 이용할 수 있습니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            "- 베이직 : 선생님과 학생 최대 100명까지 이용할 수 있습니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {}),
                            "- 프로 : 선생님과 학생 최대 500명까지 이용할 수 있습니다.",
                            /*#__PURE__*/ _jsx(TextBreak, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            marginTop: "10px"
                        },
                        children: "2. 제공되는 수업콘텐츠 라이선스의 내용과 이용 범위는 프로그램 종류와 상관없이 동일합니다."
                    })
                ]
            })
        },
        {
            title: "수업콘텐츠 라이선스 계약 후, 파일로 다운로드할 수 있나요?",
            id: 3,
            content: /*#__PURE__*/ _jsxs("div", {
                style: {
                    lineHeight: "1.5"
                },
                children: [
                    "수업콘텐츠 라이선스를 계약하신 후, 쏠북 플랫폼 뷰어로 콘텐츠를 확인 및 이용하실 수 있습니다.",
                    /*#__PURE__*/ _jsx(TextBreak, {}),
                    "쏠북은 저작권자의 권리 보호를 위해 쏠북 플랫폼 뷰어를 제공하므로,",
                    /*#__PURE__*/ _jsx(TextBreak, {}),
                    "쏠북에 접속 시 언제든지 어디서나 편리하게 이용할 수 있습니다."
                ]
            })
        },
        {
            title: "슬롯이 무엇인가요?",
            id: 4,
            content: /*#__PURE__*/ _jsxs("div", {
                style: {
                    lineHeight: "1.5"
                },
                children: [
                    "쏠북은 구매하신 수업콘텐츠 라이선스에 대해 이용할 수 있는 선생님\xb7학생수 이며, 이용 횟수와는 다릅니다.",
                    /*#__PURE__*/ _jsx(TextBreak, {}),
                    "예를 들어 선생님이 수업콘텐츠를 뷰어로 최초 열었을 때 또는 학생을 등록했을 때 최초 1회씩 슬롯이 차감되며,",
                    /*#__PURE__*/ _jsx(TextBreak, {}),
                    "선생님이 뷰어를 다시 열거나, 이미 등록한 학생을 위한 추가 인쇄를 할 때에는 슬롯이 차감되지 않습니다."
                ]
            })
        }
    ];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(IntroVideo, {}),
            /*#__PURE__*/ _jsx(FaqSectionWrapper, {
                children: /*#__PURE__*/ _jsx(Container, {
                    children: /*#__PURE__*/ _jsxs(FaqWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "title",
                                children: "자주 묻는 질문"
                            }),
                            /*#__PURE__*/ _jsx(IntroFaqs, {
                                faqs: faqs
                            })
                        ]
                    })
                })
            })
        ]
    });
};
